export default __webpack_public_path__ + "static/media/unsaved-file.ad3988b1.svg";